import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "fs-5 mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "fs-5 mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_9 = { class: "row gx-5 mt-5" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Base selection tabs"
}
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "fs-5 mb-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_17 = { class: "col-10" }
const _hoisted_18 = { class: "col-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "fs-5 mb-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_25 = { class: "col-10" }
const _hoisted_26 = { class: "col-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "fs-5 mb-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_34 = { class: "col-10" }
const _hoisted_35 = { class: "col-2" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "col-10" }
const _hoisted_40 = { class: "col-2" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_45 = { class: "card h-100" }
const _hoisted_46 = { class: "card-body d-flex flex-column" }
const _hoisted_47 = { class: "card-title" }
const _hoisted_48 = { class: "card-text" }
const _hoisted_49 = { class: "mt-auto" }
const _hoisted_50 = { class: "bg-warning missing-feature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_CategoryWithParents = _resolveComponent("CategoryWithParents")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_ProductCategoriesTree = _resolveComponent("ProductCategoriesTree")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.tabUI.getError()
    }, null, 8, ["error"]),
    (_ctx.AbilityContext.isAuthorizedForFeature('ADVANCED_MGMT_CUSTOMER_CATALOG_PRODUCTS'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_BaseCard, { class: "catalog-prices text-bg-light border-light mb-3 h-100" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('digitalPharmaCategorisation')), 1),
                      (_ctx.dpCategorisation)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('source')) + ": " + _toDisplayString(_ctx.dpCategorisation.categorization_source), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.dpCategorisation)
                    ? (_openBlock(), _createBlock(_component_BaseCardBody, {
                        key: 0,
                        class: "p-2"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dpCategorisation.categories, (category) => {
                            return (_openBlock(), _createBlock(_component_CategoryWithParents, {
                              key: category.code,
                              category: category
                            }, null, 8, ["category"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.customerCategorisationActions?.results?.length)
                ? (_openBlock(), _createBlock(_component_BaseCard, {
                    key: 0,
                    class: "catalog-prices text-bg-light border-light mb-3 h-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('adjustedCategorisation')), 1),
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCategorisation, (category) => {
                            return (_openBlock(), _createBlock(_component_CategoryWithParents, {
                              key: category.code,
                              category: category
                            }, null, 8, ["category"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("nav", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.categorizationType === _ctx.ProductCategorizationTypeEnum.CHANGE_MASTER_CATEGORIZATION}]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCategorizationType(_ctx.ProductCategorizationTypeEnum.CHANGE_MASTER_CATEGORIZATION)))
                  }, _toDisplayString(_ctx.$t('adjustCategorisation')), 3),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.categorizationType === _ctx.ProductCategorizationTypeEnum.REPLACE_MASTER_CATEGORIZATION}]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCategorizationType(_ctx.ProductCategorizationTypeEnum.REPLACE_MASTER_CATEGORIZATION)))
                  }, _toDisplayString(_ctx.$t('replaceCategorisation')), 3)
                ])
              ])
            ])
          ]),
          (_ctx.categorizationType === _ctx.ProductCategorizationTypeEnum.CHANGE_MASTER_CATEGORIZATION)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_BaseCard, { class: "catalog-prices text-bg-light border-light mb-3 h-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('addFollowingCategories')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_modal_button, {
                            class: "btn btn-icon btn-primary mb-3",
                            "modal-id": _ctx.selectCategoryModalId
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }, 8, ["modal-id"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerCategorisationActions?.results, (customerAction) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: customerAction.category.category.code
                            }, [
                              (customerAction.action.code === 'COPY_TO')
                                ? (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: customerAction.category.category.code
                                  }, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createVNode(_component_CategoryWithParents, {
                                        category: customerAction.category
                                      }, null, 8, ["category"])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("button", {
                                        class: "btn btn-icon btn-danger ms-2",
                                        onClick: ($event: any) => (_ctx.deleteCategory(customerAction))
                                      }, _hoisted_21, 8, _hoisted_19)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_BaseCard, { class: "catalog-prices text-bg-light border-light mb-3 h-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t('hideFollowingCategories')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_modal_button, {
                            class: "btn btn-icon btn-primary mb-3",
                            "modal-id": _ctx.hideCategoriesModalId
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }, 8, ["modal-id"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerCategorisationActions?.results, (customerAction) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (customerAction.action.code === 'HIDE')
                                ? (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: customerAction.category.category.code
                                  }, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode(_component_CategoryWithParents, {
                                        category: customerAction.category
                                      }, null, 8, ["category"])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("button", {
                                        class: "btn btn-icon btn-danger ms-2",
                                        onClick: ($event: any) => (_ctx.deleteCategory(customerAction))
                                      }, _hoisted_29, 8, _hoisted_27)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.categorizationType === _ctx.ProductCategorizationTypeEnum.REPLACE_MASTER_CATEGORIZATION)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_BaseCard, { class: "catalog-prices text-bg-light border-light mb-3 h-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t('replaceEverythingByFollowingCategories')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_modal_button, {
                            class: "btn btn-icon btn-primary mb-3",
                            "modal-id": _ctx.selectCategoryModalId
                          }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          }, 8, ["modal-id"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerCategorisationActions?.results, (customerAction) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (customerAction.action.code === 'MOVE_TO')
                                ? (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: customerAction.category.category.code
                                  }, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_CategoryWithParents, {
                                        category: customerAction.category
                                      }, null, 8, ["category"])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("button", {
                                        class: "btn btn-icon btn-danger ms-2",
                                        onClick: ($event: any) => (_ctx.deleteCategory(customerAction))
                                      }, _hoisted_38, 8, _hoisted_36)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.categoriesTree)
            ? (_openBlock(), _createBlock(_component_base_modal, {
                key: 2,
                "modal-id": _ctx.selectCategoryModalId,
                title: _ctx.$t('addCategory'),
                ref: "categoriesModal",
                "no-footer": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProductCategoriesTree, {
                    "categories-tree": _ctx.categoriesTree,
                    onSelectCategory: _ctx.addCategory
                  }, null, 8, ["categories-tree", "onSelectCategory"])
                ]),
                _: 1
              }, 8, ["modal-id", "title"]))
            : _createCommentVNode("", true),
          (_ctx.dpCategorisation)
            ? (_openBlock(), _createBlock(_component_base_modal, {
                key: 3,
                "modal-id": _ctx.hideCategoriesModalId,
                title: _ctx.$t('hideCategory'),
                ref: "hideCategoriesModal",
                "no-footer": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dpCategorisation.categories, (category) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row col-12",
                      key: category.category.code
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_CategoryWithParents, { category: category }, null, 8, ["category"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-danger ms-2",
                          onClick: ($event: any) => (_ctx.hideCategory(category.category.code))
                        }, _hoisted_43, 8, _hoisted_41)
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modal-id", "title"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h5", _hoisted_47, _toDisplayString(_ctx.$t('catalogProductMgmtCategory')), 1),
              _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('catalogProductMgmtCategoryDesc')), 1),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1)
              ])
            ])
          ])
        ]))
  ], 64))
}